// extracted by mini-css-extract-plugin
export var card = "index-module--card--8c07f";
export var cards = "index-module--cards--50dbe";
export var controls = "index-module--controls--65983";
export var date = "index-module--date--a632c";
export var image = "index-module--image--359fd";
export var imageWrapper = "index-module--imageWrapper--00de0";
export var info = "index-module--info--a1f4d";
export var link = "index-module--link--32d94";
export var readMore = "index-module--readMore--be4db";
export var slider = "index-module--slider--9a09a";
export var slider_container = "index-module--slider_container--c3ce4";
export var slider_slide = "index-module--slider_slide--889a4";
export var title = "index-module--title--eff15";
export var viewport = "index-module--viewport--0f9c8";